import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import middleware from 'middleware';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostContractTemplate } from 'services/templates/contract-template';
import { IContractTemplateForm } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateContractTemplate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createContractTemplate = usePostContractTemplate();

  const goBackToTemplates = () => navigate(`/templates`);
  const goBackToContractTemplate = (id: string) =>
    navigate(`/templates/contract/${id}/form`);

  const onCreateContractTemplate = async (
    values: IContractTemplateForm,
    helpers: FormikHelpers<IContractTemplateForm>
  ) => {
    const contractTemplate =
      middleware.template.contractTemplate.formToQuery(values);

    if (
      !contractTemplate.digitalDistributionSection &&
      !contractTemplate.merchDistributionSection &&
      !contractTemplate.channelDistributionSection &&
      !contractTemplate.physicalDistributionSection
    ) {
      return toast.error(t('formik-error.at-least-one-distribution'));
    }

    return await createContractTemplate.mutateAsync(contractTemplate,
      {
        onSuccess: id => goBackToContractTemplate(id),
        onError: error => onErrorShowAllErrorsToast(error),
      }
    );
  };

  return (
    <Form.Contract
      tittle={t('contract-template.contract.title')}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToTemplates}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          <Button type='submit' variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t(`button.create`)} />
          </Button>
        </>
      }
      initialStatus={contractTemplateUtil.contract.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: contractTemplateUtil.contract.initialValues,
      }}
      onSubmit={onCreateContractTemplate}
    />
  );
};

export default CreateContractTemplate;
